import React from 'react';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { firmInfo } from '../mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl">
          {/* Growth Badge */}
          <div className="mb-6">
            <span className="growth-badge">
              <TrendingUp size={16} />
              Growing Excellence Since {firmInfo.established}
            </span>
          </div>
          
          <h1 className="hero-title">
            {firmInfo.name}
          </h1>
          
          <p className="body-large mb-4 max-w-2xl leading-relaxed">
            {firmInfo.tagline}
          </p>
          
          <p className="body-medium mb-10 max-w-xl leading-relaxed">
            A dynamic and expanding chartered accountancy firm committed to delivering excellence in audit, taxation, and business advisory services across diverse industries.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToContact}
              className="btn-primary group flex items-center justify-center gap-2"
            >
              Get In Touch
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href="#services"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="btn-secondary"
            >
              Explore Our Services
            </a>
          </div>

          {/* Stats Row - Single Large Stat */}
          <div className="mt-16">
            <div className="inline-block bg-[hsl(var(--bg-card))] border border-[hsl(var(--border-light))] rounded-2xl p-8 backdrop-blur-sm">
              <div className="text-5xl font-bold text-[hsl(var(--primary-blue))] mb-2">35+</div>
              <div className="body-small text-[hsl(var(--text-muted))]">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
